import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BaseComponent } from '../../../base-component';
import { KeyIndicatorType } from '../../../user-preferences/key-indicator-type.enum';

@Component({
  standalone: false,
  selector: 'mtn-banner-comparison-mode-select',
  templateUrl: './banner-comparison-mode-select.component.html',
  styleUrls: ['./banner-comparison-mode-select.component.scss']
})
export class BannerComparisonModeSelectComponent extends BaseComponent {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string = 'keyIndicator';
  @Input()
  placeholder: string = 'Key Indicator';

  KeyIndicatorType = KeyIndicatorType;

  constructor() {
    super();
  }

}
